module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.component.css
// module id = ./src/app/settings/settings.component.css
// module chunks = main